export const LogoUrl = '/default_logo.svg';
